import Vue from 'vue'
import { decorators } from '@sohohouse/platform-resources'
import { createPlatformState, platformAction, platformGetters, platformMutations } from '~/helpers/store'

const DateTime = decorators.shared.DateTime

export default {
  state: () => {
    const state = createPlatformState()
    return {
      ...state,
      meta: {
        ...state.meta,
        fetched: false
      }
    }
  },

  actions: {
    async fetchRoomBookings ({ commit, getters }, { more = false, perPage = 3 } = {}) {
      let page = 1
      if (more) {
        if (!getters.isRoomBookingPageComplete) {
          page = getters.currentPage + 1
        } else {
          return
        }
      }

      commit('setFetched', false)

      await platformAction({
        client: this.$api.rooms.bookings,
        method: 'getAll',
        commit,
        logError: this.$logError,
        params: {
          page,
          perPage,
          filter: {
            endsAt: {
              from: new DateTime().isoString
            },
            status: 'ACTIVE'
          }
        },
        include: ['room', 'hotel', 'hotel.venue', 'payment_card', 'rate_plan']
      })
      commit('setFetched', true)
    },

    async fetchRoomBooking ({ commit }, id) {
      await platformAction({
        client: this.$api.rooms.bookings,
        method: 'get',
        commit,
        logError: this.$logError,
        params: id,
        include: ['room', 'hotel', 'hotel.venue', 'payment_card', 'rate_plan']
      })
    },

    async createRoomBooking ({ commit, getters }, data) {
      const booking = await platformAction({
        client: this.$api.rooms.bookings,
        method: 'create',
        commit,
        logError: this.$logError,
        params: data,
        commitData: false,
        include: []
      })

      if (!getters.failed) {
        commit('setRecentlyCreated', booking)
      }
    },

    async updateRoomBooking ({ commit, getters, dispatch }, data) {
      await platformAction({
        client: this.$api.rooms.bookings,
        method: 'update',
        commit,
        logError: this.$logError,
        params: data,
        commitData: false,
        include: []
      })
      if (!getters.failed) {
        await dispatch('fetchRoomBooking', data.id)
      }
    },

    async deleteRoomBooking ({ commit, getters }, id) {
      await platformAction({
        client: this.$api.rooms.bookings,
        method: 'delete',
        params: id,
        commit,
        logError: this.$logError,
        simple: false
      })

      if (!getters.failed) {
        commit('setCancelledBooking', id)
      }
    }
  },

  getters: {
    ...platformGetters,

    getRecentlyCreated: s => {
      if (s.meta.recent) {
        return s.meta.recent
      }
      return null
    },

    getBooking: (_, getters) => id => {
      const booking = getters.resourceById(id)
      if (booking && !booking.cancelled) {
        return booking
      }
      return null
    },

    getCancelledBooking: (_, getters) => id => {
      const booking = getters.resourceById(id)
      if (booking && booking.cancelled) {
        return booking
      }
      return null
    },

    getRoomBookings: (_, getters) => getters.resources.filter(booking => !booking.cancelled),

    isRoomBookingPageComplete: (_, getters) => getters.totalPages <= getters.currentPage,

    roomBookingFetched: s => s.meta.fetched
  },
  mutations: {
    ...platformMutations,

    setCancelledBooking: (s, id) => {
      Vue.set(s.data[id], 'cancelled', true)
    },

    setRecentlyCreated: (s, booking) => {
      Vue.set(s.meta, 'recent', booking)
    },

    setFetched: (s, value) => {
      Vue.set(s.meta, 'fetched', value)
    }
  }
}
